import React from 'react'
import { Storage  } from './components/Storage'


export const App = () => {
  return (
    <div>
      <Storage/>
      
      
    </div>
  )
}

